import { IItem, castDirectusItemToEntity } from "~/entities/item";

export function transformNestedDataToItem(
  parentCollectionName: string,
  data: Record<string, any>,
): IItem {
  return castDirectusItemToEntity(parentCollectionName, data);
}
